var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fb8500",
    width: "20px",
    height: "20px",
    viewBox: "0 0 1920 1920",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1521.461 53c-103.466 0-199.466 42.667-266.666 113.067-37.334 37.333-66.134 83.2-84.267 134.4-14.933 38.4-22.4 81.066-22.4 125.866 0 19.307 2.027 38.4 5.333 57.387 2.774 17.92 7.254 35.307 12.374 52.587v.106c1.813 5.974 2.666 12.16 4.693 17.92 3.2 8.534 7.467 18.134 9.6 21.334 1.067 3.2 3.2 7.466 5.333 10.666 19.2 43.734 46.934 82.134 85.334 115.2 1.493 1.28 13.44 10.134 31.36 21.76-5.76 30.187-17.6 59.52-40.854 82.88-62.506 62.4-163.84 62.4-226.346 0-62.4-62.506-62.4-163.84 0-226.346 8.426-8.32 18.773-12.694 28.373-18.774-13.013-42.24-21.867-88.32-21.867-134.72 0-56 9.494-109.973 28.694-160H745.14L-.032 1011.4l829.76 829.76 745.067-745.173V426.333c0-88.213-71.787-160-160-160h-106.56c48.96-65.6 127.68-106.666 213.226-106.666 147.2 0 266.667 119.466 266.667 266.666h106.667C1894.795 220.467 1727.328 53 1521.46 53",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.246475f92a62c647e504a9cd2aeea178.svg";
export { ForwardRef as ReactComponent };